<script>
import { onMount, onDestroy } from 'svelte'

import Icon from "fa-svelte";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons/faSignOutAlt";

// import { user as userStore} from "./userStore.js";
import { user } from "./userStore.js";


let name;
let email;
let password;
let errorCode;
let errorMessage;

let stateRegisterPage = true;
// let userFb = {};
// let firstPageLoading = true;

// let userEmail = window.id_current_user_email ? window.id_current_user_email : "";
let url = new URL(window.location.href);
let queryQ = url.searchParams.get("q");// || "none";
let queryEmail = url.searchParams.get("email");
let queryName = url.searchParams.get("name");
let queryId = url.searchParams.get("id");
if (queryEmail && queryName && queryId && queryQ) {
    localStorage.setItem("fromKhasangIo", true); 
    localStorage.setItem("fromKhasangIoName", queryName);
    localStorage.setItem("fromKhasangIoEmail", queryEmail);
    localStorage.setItem("fromKhasangIoId", queryId);
    if (window.history.replaceState) {
        window.history.replaceState({}, "Khasang.Quests", "/?q=" + queryQ);
    }
}

// let initApp = function() {
//     firebase.auth().onAuthStateChanged(function(user) {
//         if (user) {
//         // User is signed in.
//         var displayName = user.displayName;
//         var email = user.email;
//         var emailVerified = user.emailVerified;
//         var photoURL = user.photoURL;
//         var uid = user.uid;
//         var phoneNumber = user.phoneNumber;
//         var providerData = user.providerData;

//         userFb = user;
//         userStore.setUserId(uid, q);

//         user.getIdToken().then(function(accessToken) {
//             document.getElementById('sign-in-status').textContent = 'Signed in';
//             document.getElementById('sign-in').textContent = 'Sign out';
//             document.getElementById('account-details').textContent = JSON.stringify({
//             displayName: displayName,
//             email: email,
//             emailVerified: emailVerified,
//             phoneNumber: phoneNumber,
//             photoURL: photoURL,
//             uid: uid,
//             accessToken: accessToken,
//             providerData: providerData
//             }, null, '  ');
//         });
//         } else {
//             userFb = undefined;
//             // User is signed out.
//             document.getElementById('sign-in-status').textContent = 'Signed out';
//             document.getElementById('sign-in').textContent = 'Sign in';
//             document.getElementById('account-details').textContent = 'null';
//         }
//     }, function(error) {
//         console.log(error);
//     });
// };

// initApp();

onMount(() => {  
    let fromKhasangIo = localStorage.getItem("fromKhasangIo"); // boolean
    let lsName = localStorage.getItem("fromKhasangIoName");
    let lsEmail = localStorage.getItem("fromKhasangIoEmail");
    let lsId = localStorage.getItem("fromKhasangIoId");
    if (fromKhasangIo && lsName && lsEmail && lsId) {
        localStorage.removeItem("fromKhasangIo");
        localStorage.removeItem("fromKhasangIoName");
        localStorage.removeItem("fromKhasangIoEmail");
        localStorage.removeItem("fromKhasangIoId");
        name = lsName;
        email = lsEmail;
        password = lsEmail.slice(0, 4) + lsId.slice(0, 4);
        user.signInWithEmailAndPassword(email, password, () => {
            user.createUserWithEmailAndPassword(email, password, name, ()=>{});
        });       
    }

    // // FirebaseUI config.
    // var uiConfig = {
    // signInSuccessUrl: 'https://ya.ru', // '<url-to-redirect-to-on-success>',
    // signInOptions: [
    //     // Leave the lines as is for the providers you want to offer your users.
    //     firebase.auth.EmailAuthProvider.PROVIDER_ID,
    //     firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
    // ],
    // // tosUrl and privacyPolicyUrl accept either url string or a callback
    // // function.
    // // Terms of service url/callback.
    // tosUrl: '<your-tos-url>',
    // // Privacy policy url/callback.
    // privacyPolicyUrl: function() {
    //     window.location.assign('<your-privacy-policy-url>');
    // }
    // };

    // // Initialize the FirebaseUI Widget using Firebase.
    // var ui = new firebaseui.auth.AuthUI(firebase.auth());
    // // The start method will wait until the DOM is loaded.
    // // if (ui.isPendingRedirect()) {
    // ui.start('#firebaseui-auth-container', uiConfig);
    // // }
});
// async function logIn() {
//     // firebase.auth().signInAnonymously().catch(function(error) {
//     //     // Handle Errors here.
//     //     var errorCode = error.code;
//     //     var errorMessage = error.message;
//     //     // ...
//     //      console.log("signInAnonymously" + errorCode + " " + errorMessage);  
//     // });

//     try {
//         await firebase.auth().signInAnonymously();
//         console.log("login");
//     } catch (e){
//         // an error
//     } 
// }

// async function logOut() {
//     try {
//         await firebase.auth().signOut();
//         // signed out
//     } catch (e){
//         // an error
//     } 
// }
// logOut();

function cb(c, m) {
    errorCode = c;
    errorMessage = m;
}
</script>

<style>
button.as-link {
  background: none!important;
  border: none;
  padding: 0!important;
  /*optional*/
  font-family: arial, sans-serif;
  /*input has OS specific font-family*/
  color: #069;
  /* text-decoration: underline; */
  cursor: pointer;
}
button.as-link:hover{
  text-decoration:underline;
}

button.exit {
    opacity: 0;
}

.user-menu {
    text-align: right;
}

.user-menu:hover .exit {
    opacity: 1;
}
</style>

<div class="main">
{#if $user.onauth}
    {#if !$user.loggedin}
        <div style="width:400px; margin:0 auto;text-align: center;  position: absolute;  top: 20%; left: 50%;right: 50%;  margin: -100px 0 0 -200px;">
            <div style="text-align:left">
        <h3>Khasang.Quests</h3>
                {#if stateRegisterPage}
                    <label>          
                        Имя:<br>
                        <input class="hw" bind:value={name} placeholder="" on:click|stopPropagation/>
                    </label>        
                {/if}
                <label>          
                    Емейл:<br>
                    <input class="hw" bind:value={email} placeholder="" on:click|stopPropagation/>
                </label>
                <label>          
                    Пароль:<br>
                    <input class="hw" bind:value={password} placeholder="" type="password" on:click|stopPropagation/>
                </label>
                {#if errorCode}
                    <div>{errorCode} ({errorMessage})</div>
                {/if}
                    <!-- history.replaceState({}, document.title, "."); -->
                <button on:click="{()=>{
                    errorCode = null; 
                    user.createUserWithEmailAndPassword(email, password, name, cb)}}" hidden={!stateRegisterPage}
                    >Зарегистрироваться</button>
                <button on:click="{()=>{
                    errorCode = null; 
                    user.signInWithEmailAndPassword(email, password, cb)}}" hidden={stateRegisterPage}
                    >Войти</button>                
                <br><br>
                <button on:click="{()=>{stateRegisterPage = false; errorCode = null}}" hidden={!stateRegisterPage}
                class="as-link">Уже есть аккаунт? Войти...</button>
                <button on:click="{()=>{stateRegisterPage = true; errorCode = null}}" hidden={stateRegisterPage}
                class="as-link">Еще нет аккаунта? Зарегистрироваться...</button>                
                
                <!-- <br><button on:click="{user.signInAnonymously}" hidden={!stateRegisterPage}
                class="as-link"><small>(или временно войти как гость)</small></button> -->

                <!-- <a href="#login" on:click|stopPropagation="{()=>{stateRegisterPage = false; errorCode = null}}" hidden={!stateRegisterPage}
                >Уже есть аккаунт? Войти</a>
                <a href="#registration" on:click|stopPropagation="{()=>{stateRegisterPage = true; errorCode = null}}" hidden={stateRegisterPage}
                >Еще нет аккаунта? Зарегистрироваться</a> -->
            </div>
        </div>
    {:else}
        <div class="user-menu">
            👤{$user.onAuthName || ""}
            <!-- ({$user.id}) -->
            <button class="exit" on:click="{user.signOut}">
            <!-- Выйти -->
            <Icon class="myClass1 myClass2" icon={faSignOutAlt} />            
            </button>
        </div>
    {/if}
{/if}
<br>
</div>

    <!-- <div id="sign-in-status"></div>
    <div id="sign-in"></div>
    <pre id="account-details"></pre> -->

<!-- <div id="firebaseui-auth-container"></div> -->
<!-- <svelte:head>
    {@html '<script src="https://www.gstatic.com/firebasejs/ui/4.5.1/firebase-ui-auth__ru.js"></script>'}
    {@html '<link type="text/css" rel="stylesheet" href="https://www.gstatic.com/firebasejs/ui/4.5.1/firebase-ui-auth.css" />'}
</svelte:head> -->

<!-- ERROR auth/network-request-failed A network error (such as timeout, interrupted connection or unreachable host) has occurred. -->
